import { Box, Card, Heading, Stack, chakra } from "@chakra-ui/react"
import { motion } from "framer-motion"

// Wrap Chakra components with chakra() first, then wrap with motion().
// motion(...) will consume motion props (e.g., layoutId, initial, animate)
// before forwarding the rest to the inner Chakra component, preventing DOM leakage.
export const MotionBox = motion(chakra(Box))
export const MotionCard = motion(chakra(Card))
export const MotionHeading = motion(chakra(Heading))
export const MotionStack = motion(chakra(Stack))
